export let CollapsibleTriggerDataAttributes = /*#__PURE__*/function (CollapsibleTriggerDataAttributes) {
  /**
   * Present when the collapsible panel is open.
   */
  CollapsibleTriggerDataAttributes["panelOpen"] = "data-panel-open";
  return CollapsibleTriggerDataAttributes;
}({});